import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
  ViewChild,
  ElementRef,
  Renderer2,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { LoadingService } from './../../../core/services/loader.service';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationService } from './../../../core/services/authentication.service';
import { ThemePalette, DateAdapter } from '@angular/material/core';
import {
  MatFormField,
  MatFormFieldControl,
} from '@angular/material/form-field';
import { Subject, Subscription } from 'rxjs';
import {
  MyTel,
  TelInputComponent,
} from '../../users/tel-input/tel-input.component';
import { UsersService } from '../../users/services/users.service';
import { LoginComponent } from '../../users/login/login.component';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { ForgotPasswordComponent } from '../../users/forgot-password/forgot-password.component';
import { LoginOtpComponent } from '../../users/login-otp/login-otp.component';
import { ConfirmationPopupComponent } from '../../users/confirmation-popup/confirmation-popup.component';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SuperAnnuationService } from '../../superannuation/services/superannuation.service';
import { HealthInsuranceService } from '../../health-insurance/services/health-insurance.service';
import { invalid } from 'moment';

enum housingSituation {
  BOARDING = '1',
  CARAVAN = '2',
  OWN_HOME = '3',
  Own_Home_Mortgage = '4',
  RENTING = '5',
  WITH_PARENTS = '6',
  OTHER = '7',
}
enum eCitizenship {
  CITIZEN = '854500000',
  RESIDENT = '854500001',
  NON_RESIDENT = '854500002',
}
@Component({
  selector: 'app-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.scss'],
  providers: [{ provide: MatFormFieldControl, useExisting: TelInputComponent }],
})
export class UserFormComponent implements OnInit, OnDestroy {
  selected = 'option2';

  minTab = 1;
  isLinear = false;
  citizenship: 'citizenship';
  resetFormSubscription: Subscription;
  applicationForm: FormGroup;
  addressForm: FormGroup;

  submitted = false;
  header = '';
  mobileTouched = false;
  currentStage = 1;
  totalStage = 10;
  addressSubmit: boolean;
  routeUrl: string;
  visibility = false;
  subscription: any;
  progInfoSubscription: any;
  todayDate: Date = new Date();
  housSituation = housingSituation;
  citizenShip = eCitizenship;
  isShowAddress = true;
  @Output() headerMenuEvent = new EventEmitter();

  monthTotal: any;
  addressId = false;
  addressdata: any;
  loading = false;
  isredColor = false;
  color: ThemePalette = 'accent';
  // isLogin = false;
  // phone = {
  //   area: '',
  //   exchange: '',
  //   subscriber: '',
  // };
  emailSubject = new Subject();
  currentApplication = '';
  currenUrl = '';
  nextUrl = '';
  showMobileInput = false;
  constructor(
    private el: ElementRef,
    private formBuilder: FormBuilder,
    private userService: UsersService,
    public auth: AuthenticationService,
    private loadingService: LoadingService,
    public dialog: MatDialog //  private dateAdapter: DateAdapter<Date>
  ) {}
  events: any;
  contactId: any;
  addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      const date = Number(event.value.getMonth()) + 1;
      this.events =
        event.value.getFullYear() + '-' + date + '-' + event.value.getDate();
    }
  }
  getFormattedDate(date: Date) {
    const day = Number(date.getMonth()) + 1;
    return date.getFullYear() + '-' + day + '-' + date.getDate();
  }
  ngOnInit(): void {
    // this.isLogin = this.auth.isLoggedIn;
    this.checkCurrentUrl();
    const userData = this.auth.getDecodedUserAccessToken();

    this.contactId = this.auth.getLoginUserId();
    this.applicationForm = this.formBuilder.group({
      accountId: [''],
      firstname: ['', [Validators.required, Validators.maxLength(50)]],
      lastname: ['', [Validators.required, Validators.maxLength(50)]],
      mobilephone: ['', Validators.required],
      // mobilephone: new FormControl(new MyTel('', '', ''), Validators.required),
      birthdate: ['', Validators.required],
      // emailaddress1: ['',[Validators.required,Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),],],
      emailaddress1: ['', [Validators.required, Validators.email]],

      gendercode: ['', Validators.required],
      tlx_residentialstatus: ['', Validators.required],
      tlx_australiantaxresident: ['', Validators.required],
      isAgree: ['', Validators.required],
      msdyn_portaltermsagreementdate: ['1994-04-30'],
    });
    this.addressForm = this.formBuilder.group({
      leadFor: [''],
      contactId: [''],
      firstname: [''],
      lastname: [''],
      birthdate: [''],
      gendercode: [''],
      pst_identityvoiresult: [''],
      new_creditscorelatestreportdate: [''],

      dateCommenced: ['', Validators.required],
      tlx_sameashomeaddress: ['true'],
      homeAddress: this.formBuilder.group({
        tlx_addresstype: ['854500000'],
        tlx_addressid: [''],
        tlx_street: [''],
        new_streetnumber: ['', Validators.required],
        tlx_streetaddress2: ['', Validators.required],
        new_streettype: [''],
        new_country: [
          '18952afd-55eb-ea11-a815-000d3a799a0d',
          Validators.required,
        ],
        new_state: ['', Validators.required],
        tlx_city: ['', Validators.required],
        tlx_postcode: ['', Validators.required],
        new_housingsituation: ['1', Validators.required],
        contactId: [this.contactId],
      }),
      previousAddress: this.formBuilder.group({
        tlx_addresstype: ['854500001'],
        tlx_addressid: [''],
        tlx_street: [''],
        new_streetnumber: ['', Validators.required],
        tlx_streetaddress2: ['', Validators.required],
        new_streettype: [''],
        new_country: [
          '18952afd-55eb-ea11-a815-000d3a799a0d',
          Validators.required,
        ],
        new_state: ['', Validators.required],
        tlx_city: ['', Validators.required],
        tlx_postcode: ['', Validators.required],
        new_housingsituation: ['1'],
        contactId: [this.contactId],
      }),
      postalAddress: this.formBuilder.group({
        tlx_addresstype: ['854500003'],
        tlx_addressid: [''],
        tlx_street: [''],
        new_streetnumber: [''],
        tlx_streetaddress2: [''],
        new_streettype: [''],
        new_country: ['18952afd-55eb-ea11-a815-000d3a799a0d'],
        new_state: [''],
        tlx_city: [''],
        tlx_postcode: [''],
        new_housingsituation: ['1'],
        contactId: [this.contactId],
      }),
    });

    this.addressForm.controls.dateCommenced.valueChanges.subscribe((change) => {
      const selectedDay = new Date();
      const today = new Date();
      const month = this.monthDiff(selectedDay, today);

      if (month > 23) {
        this.isShowAddress = false;
        this.addressForm.controls.previousAddress.disable();
      } else {
        this.isShowAddress = true;
        this.addressForm.controls.previousAddress.enable();
      }
    });
    // if (this.auth.isLoggedIn) {
    //   this.getUserDetail();
    // }

    if (userData) {
      this.setformdata(userData);
    }

    if (this.resetFormSubscription) {
      this.resetFormSubscription.unsubscribe();
    }
    this.resetFormSubscription = this.auth.resetUserForm.subscribe((value) => {
      if (value) {
        this.applicationForm.reset();
      } else {
        const userdetail = this.auth.getDecodedUserAccessToken();
        if (userdetail) {
          this.setformdata(userdetail);
          // this.ngOnInit();
          window.scroll(0, 0);
        }
      }
    });
    if (!this.auth.isLoggedIn) {
      this.emailSubject
        .pipe(debounceTime(1000), distinctUntilChanged())
        .subscribe((value) => {
          this.checkEmail();
        });
    }
  }

  setformdata(data) {
    const userdata = {
      firstname: data.contactDetails[0].firstname,
      lastname: data.contactDetails[0].lastname,
      emailaddress1: data.contactDetails[0].emailaddress1,
      birthdate: new Date(data.contactDetails[0].birthdate),
      isAgree: true, ///////
      mobilephone: data.contactDetails[0].mobilephone,
      gendercode: data.contactDetails[0].gendercode + '', ///
      tlx_residentialstatus: data.contactDetails[0].tlx_residentialstatus + '', //////
      msdyn_portaltermsagreementdate: '1994-04-30', //////////
      tlx_australiantaxresident:
        data.contactDetails[0].tlx_australiantaxresident, ///
    };

    this.applicationForm.patchValue(userdata);
    this.showMobileInput = true;
    // if(data.contactDetails[0].emailaddress1) {
    //   this.applicationForm.get('emailaddress1').disable()
    // }
    // // this.phone.area = data.contactDetails[0].mobilephone.substring(0, 4);
    // // this.phone.exchange = data.contactDetails[0].mobilephone.substring(4, 7);
    // // this.phone.subscriber = data.contactDetails[0].mobilephone.substring(7, 10);
    // // this.applicationForm.controls['mobilephone'].setValue(this.phone);
  }

  logout() {
    this.auth.logout();
    this.applicationForm.reset();
  }

  monthDiff(d1, d2) {
    let months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    this.monthTotal = months;
    return months <= 0 ? 0 : months;
  }

  get applicationF() {
    return this.applicationForm.controls;
  }
  get addressFormControl() {
    return this.addressForm.controls;
  }

  ngOnDestroy() {
    this.resetFormSubscription.unsubscribe();
    this.emailSubject?.unsubscribe();
    this.loadingService.stopLoading();
  }

  checkPostalAddress(event) {
    if (event.value == 'true') {
      this.addressForm.get('tlx_sameashomeaddress').setValue('true');

      this.addressForm.get('postalAddress.new_streetnumber').clearValidators();
      this.addressForm
        .get('postalAddress.tlx_streetaddress2')
        .clearValidators();
      this.addressForm.get('postalAddress.new_streettype').clearValidators();

      this.addressForm.get('postalAddress.new_state').clearValidators();
      this.addressForm.get('postalAddress.tlx_city').clearValidators();
      this.addressForm.get('postalAddress.new_country').clearValidators();
      this.addressForm.get('postalAddress.tlx_postcode').clearValidators();

      this.addressForm
        .get('postalAddress.new_streetnumber')
        .updateValueAndValidity();
      this.addressForm
        .get('postalAddress.tlx_streetaddress2')
        .updateValueAndValidity();
      this.addressForm
        .get('postalAddress.new_streettype')
        .updateValueAndValidity();

      this.addressForm.get('postalAddress.new_state').updateValueAndValidity();
      this.addressForm.get('postalAddress.tlx_city').updateValueAndValidity();
      this.addressForm
        .get('postalAddress.new_country')
        .updateValueAndValidity();
      this.addressForm
        .get('postalAddress.tlx_postcode')
        .updateValueAndValidity();
      // this.addressForm.controls.postalAddress.setValue(
      //   this.addressForm.controls.homeAddress.value
      // );
      // this.addressForm
      //   .get('postalAddress.tlx_addresstype')
      //   .setValue('854500003');

      //  this.addressForm.controls.postalAddress.updateValueAndValidity();
      // this.addressForm.controls.postalAddress.disable();
    } else {
      this.addressForm.get('tlx_sameashomeaddress').setValue('false');
      this.addressForm
        .get('postalAddress.new_state')
        .setValidators(Validators.required);
      this.addressForm
        .get('postalAddress.tlx_city')
        .setValidators(Validators.required);
      this.addressForm
        .get('postalAddress.tlx_postcode')
        .setValidators(Validators.required);
      this.addressForm
        .get('postalAddress.new_streetnumber')
        .setValidators(Validators.required);
      this.addressForm
        .get('postalAddress.tlx_streetaddress2')
        .setValidators(Validators.required);
      // this.addressForm
      //   .get('postalAddress.new_streettype')
      //   .setValidators(Validators.required);

      this.addressForm
        .get('postalAddress.new_country')
        .setValidators(Validators.required);
      this.addressForm.get('postalAddress').updateValueAndValidity();
      // this.addressForm.controls.postalAddress.reset();
      // this.addressForm.controls.postalAddress.updateValueAndValidity();
      // this.addressForm.controls.postalAddress.enable();
      // this.addressForm
      //   .get('postalAddress.tlx_addresstype')
      //   .setValue('854500003');
      // this.addressForm.get('postalAddress.contactId').setValue(this.contactId);
      // this.addressForm.get('postalAddress.new_housingsituation').setValue('1');
    }
  }

  onSubmit() {
    this.isredColor = true;
    this.submitted = true;
    this.mobileTouched = true;
    if (this.applicationForm.invalid) {
      if (
        !this.applicationForm.get('firstname').invalid &&
        !this.applicationForm.get('lastname').invalid &&
        !this.applicationForm.get('emailaddress1').invalid &&
        !this.applicationForm.get('mobilephone').invalid &&
        this.applicationForm.get('birthdate').invalid
      ) {
        this.auth.showSnackBarMsg(
          'Invalid Date : Please input date in form of DD/MM/YYYY.'
        );
      } else {
        if (this.applicationForm.get('emailaddress1').invalid) {
          this.auth.showSnackBarMsg('Invalid email : please fill valid email.');
        } else {
          this.auth.showSnackBarMsg('Please fill all details.');
        }
      }
      const invalidControl = document.getElementsByClassName('ng-invalid');
      const inputIndex = Array.from(invalidControl)?.findIndex(
        (el) => el.tagName == 'INPUT' || el.tagName == 'MAT-SELECT'
      );
      if (inputIndex >= 0) {
        (invalidControl[inputIndex] as HTMLElement).focus();
      }
      return;
    }
    if (
      this.applicationForm.value.isAgree == false &&
      this.applicationForm.value.isAgree == ''
    ) {
      this.auth.showSnackBarMsg('Please accept terms and privacy policy.');
      return;
    }
    const token = this.auth.getUserAccessToken();
    if (this.applicationForm.valid) {
      this.loadingService.startLoading();
      this.loading = true;
      if (this.auth.isLoggedIn) {
        delete this.applicationForm.value.isAgree;
        delete this.applicationForm.value.msdyn_portaltermsagreementdate;
        this.applicationForm.value.contactId = this.auth.getLoginUserId();
        this.applicationForm.value.accountId = this.auth.getUserAccountId();
        delete this.applicationForm.value.image;
        this.applicationForm.value.birthdate = this.events
          ? this.events
          : this.getFormattedDate(this.applicationForm.value.birthdate);

        if (this.applicationForm.dirty) {
          this.userService
            .updateApplication(token, this.applicationForm.value)
            .subscribe(
              (response) => {
                this.loadingService.stopLoading();
                this.loading = false;
                if (response.success) {
                  //   this.validateOpportunity();

                  const userDataToken = this.auth.getDecodedUserAccessToken();
                  userDataToken.contactDetails[0].firstname =
                    this.applicationForm.value.firstname;
                  userDataToken.contactDetails[0].lastname =
                    this.applicationForm.value.lastname;
                  userDataToken.contactDetails[0].emailaddress1 =
                    this.applicationForm.value.emailaddress1;
                  userDataToken.contactDetails[0].birthdate =
                    this.applicationForm.value.birthdate;
                  userDataToken.contactDetails[0].mobilephone =
                    this.applicationForm.value.mobilephone;
                  userDataToken.contactDetails[0].gendercode =
                    +this.applicationForm.value.gendercode;
                  userDataToken.contactDetails[0].tlx_residentialstatus =
                    +this.applicationForm.value.tlx_residentialstatus;
                  userDataToken.contactDetails[0].tlx_australiantaxresident =
                    this.applicationForm.value.tlx_australiantaxresident;
                  userDataToken.contactDetails[0].fullname =
                    this.applicationForm.value.firstname +
                    ' ' +
                    this.applicationForm.value.lastname;
                  this.auth.setDecodedToken(userDataToken);
                }
              },
              (err) => {
                console.log(err);
                this.loadingService.stopLoading();
                this.loading = false;
                //  alert(err.message.message);
                this.auth.showSnackBarMsg(err.message.message);
              }
            );
        } else {
          this.loadingService.stopLoading();
          this.loading = false;

          this.userService
            .updatePrivacyConsentDate(token, {accountId: this.applicationForm.value.accountId})
            .subscribe((response) => { });
        }
        this.changeMinTab(this.minTab + 1);
        this.setAddress();
        this.contactId = this.auth.getLoginUserId();
        this.addressForm.value.homeAddress.contactId = this.contactId;
        this.addressForm.value.previousAddress.contactId =
          this.contactId;
        this.addressForm.value.postalAddress.contactId = this.contactId;
        this.addressdata = this.addressForm.value;
      } else {
        // this.applicationForm.value.tlx_portalcurrentpage = 1;
        this.applicationForm.value.birthdate = this.events
          ? this.events
          : this.getFormattedDate(this.applicationForm.value.birthdate);
        //   this.applicationForm.value.mobilephone = `${this.phone.area}${this.phone.exchange}${this.phone.subscriber}`;
        this.userService.saveApplication(this.applicationForm.value).subscribe(
          (response) => {
            this.loadingService.stopLoading();
            this.loading = false;
            if (response.success) {
              this.auth.showSnackBarMsg(
                'Your account has been created please check your mail box'
              );
              const email = this.applicationForm.get('emailaddress1').value;
              this.applicationForm.reset();
              const msg = `Your account has been created please check your ${email}  mail box`;
              const header = 'Account Created.';

              this.openConfirmationPopup(email, header, msg);
            }
          },
          (err) => {
            this.loadingService.stopLoading();
            this.loading = false;
            console.log('error', err);
            if (err.error.message === 'Record already exist!') {
              this.auth.showSnackBarMsg(
                'Your email already exist, Please Login!'
              );
              this.openDialog('Already a client?');
            } else if (err.error.message === 'check email') {
              const msg =
                'As a first time applicant, an email has been sent to ' +
                this.applicationForm.get('emailaddress1').value +
                '. Please follow the prompts to create a password and to continue with the application.';
              const header = 'Create Password!';
              this.openConfirmationPopup(
                this.applicationForm.get('emailaddress1').value,
                header,
                msg
              );
            } else {
              //  alert(err.error.message);
              this.auth.showSnackBarMsg(err.error.message);
            }
          }
        );
      }
    }
  }

  openConfirmationPopup(email, header: string, content: string) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      width: '500px',
      data: { email, header, content },
    });
  }

  onEmailKeyup() {
    const searchText = this.applicationForm.get('emailaddress1').value;
    this.emailSubject?.next(searchText);
  }
  checkEmail() {
    // this.loadingService.startLoading();
    const email = this.applicationForm.get('emailaddress1').value;
    if (email && this.validateEmail(email)) {
      this.userService.getUserByEmail(email).subscribe(
        (response) => {
          if (response.data == 'check email') {
            const msg =
              'As a first time applicant, an email has been sent to ' +
              email +
              '. Please follow the prompts to create a password and to continue with the application.';
            const header = 'Create Password!';
            this.openConfirmationPopup(email, header, msg);
          } else if (response.data == 'user exist!') {
            this.auth.showSnackBarMsg(
              'Your email already exist, Please Login!'
            );
            this.openDialog('Already a client?');
          }
          // this.loadingService.stopLoading()
        },
        (err) => {
          // this.loadingService.stopLoading()
          console.log('error', err);
        }
      );
    }
  }
  validateEmail(email) {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  }
  setAddress() {
    if (this.auth.isLoggedIn) {
      const token = this.auth.getUserAccessToken();
      const id = this.auth.getLoginUserId();
      this.loadingService.startLoading();
      this.userService.getAdress(token, id).subscribe(
        (response) => {
          if (response.data[0]?.tlx_addressid) {
            this.addressId = true;
            response.data.forEach((element) => {
              if (element.tlx_addresstype === '854500000') {
                this.addressForm.controls.homeAddress.patchValue(element);
                this.addressForm.controls.dateCommenced.patchValue(
                  element.new_from
                );
              } else if (element.tlx_addresstype === '854500001') {
                this.addressForm.controls.previousAddress.patchValue(element);
              } else if (element.tlx_addresstype === '854500003') {
                if (element.tlx_sameashomeaddress) {
                  this.checkPostalAddress({ value: 'true' });
                  this.addressForm.controls.postalAddress.patchValue(element);
                } else {
                  this.checkPostalAddress({ value: 'false' });
                  this.addressForm.controls.postalAddress.patchValue(element);
                }
              }
            });

            // this.addressForm.value.homeAddress = response.data[0];
            // this.addressForm.value.previousAddress = response.data[1];
            // this.addressForm.value.postalAddress = response.data[2];
            this.addressdata = this.addressForm.value;
          }
          this.loadingService.stopLoading();
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.loadingService.stopLoading();
          this.loading = false;
          //  alert(err.message.message);
          this.auth.showSnackBarMsg(err.message.message);
        }
      );
    }
  }

  goPrevious() {
    this.changeMinTab(this.minTab - 1);
  }
  changeMinTab(value: number) {
    this.minTab = value;
    if (this.currentApplication == 'debtapp') {
      if (value == 1) {
        this.header = 'Finance Application';
        this.totalStage = 10;
        this.currentStage = 1;
        // this.currentApplication = 'debtapp';
      }
      if (value == 2) {
        this.header = 'Confirm Your Address Details.';
        this.totalStage = 10;
        this.currentStage = 1;
        //  this.currentApplication = 'debtapp';
      }
    }
    if (this.currentApplication == 'superannuation') {
      if (value == 1) {
        this.header = 'Join Cashel Super and Pension.';
        this.totalStage = 9;
        this.currentStage = 1;
        //  this.currentApplication = 'superannuation';
      }
      if (value == 2) {
        this.header = 'Confirm Your Address Details.';
        this.totalStage = 9;
        this.currentStage = 2;
        //  this.currentApplication = 'superannuation';
      }
    }
    if (this.currentApplication == 'managedAccount') {
      if (value == 1) {
        this.header = 'Apply for Cashel Managed Account';
        this.totalStage = 6;
        this.currentStage = 1;
        // this.currentApplication = 'debtapp';
      }
      if (value == 2) {
        this.header = 'Confirm Your Address Details.';
        this.totalStage = 6;
        this.currentStage = 2;
        //  this.currentApplication = 'debtapp';
      }
    }
    if (this.currentApplication == 'generalInsurance') {
      if (value == 1) {
        this.header = 'Apply for General Insurance';
        this.totalStage = 4;
        this.currentStage = 1;
        // this.currentApplication = 'debtapp';
      }
      if (value == 2) {
        this.header = 'Confirm Your Address Details.';
        this.totalStage = 4;
        this.currentStage = 2;
        //  this.currentApplication = 'debtapp';
      }
    }
    if (this.currentApplication == 'healthInsurance') {
      if (value == 1) {
        this.header = 'Apply for Health Insurance Review';
        this.totalStage = 4;
        this.currentStage = 1;
        // this.currentApplication = 'debtapp';
      }
      if (value == 2) {
        this.header = 'Confirm Your Address Details.';
        this.totalStage = 4;
        this.currentStage = 2;
        //  this.currentApplication = 'debtapp';
      }
    }
    if (this.currentApplication == 'estatePlanning') {
      if (value == 1) {
        this.header = 'Obtain Estate Planning Assistance';
        this.totalStage = 10;
        this.currentStage = 1;
        // this.currentApplication = 'debtapp';
      }
      if (value == 2) {
        this.header = 'Confirm Your Address Details.';
        this.totalStage = 10;
        this.currentStage = 2;
        //  this.currentApplication = 'debtapp';
      }
    }
    if (this.currentApplication == 'lifeInsurance') {
      if (value == 1) {
        this.header = 'Apply for Life and Personal Insurance.';
        this.totalStage = 12;
        this.currentStage = 1;
        // this.currentApplication = 'debtapp';
      }
      if (value == 2) {
        this.header = 'Confirm Your Address Details.';
        this.totalStage = 12;
        this.currentStage = 2;
        //  this.currentApplication = 'debtapp';
      }
    }
    if (this.currentApplication == 'financialPlanning') {
      if (value == 1) {
        this.header = 'Obtain Financial Planning Advice.';
        this.totalStage = 12;
        this.currentStage = 1;
        // this.currentApplication = 'debtapp';
      }
      if (value == 2) {
        this.header = 'Confirm Your Address Details.';
        this.totalStage = 12;
        this.currentStage = 2;
        //  this.currentApplication = 'debtapp';
      }
    }
  }
  onAddressSubmit() {
    this.loadingService.startLoading();
    this.addressSubmit = true;
    if (this.addressForm.invalid) {
      this.auth.showSnackBarMsg('Please Fill all Address!');
      const invalidControl = document.getElementsByClassName('ng-invalid');
      const inputIndex = Array.from(invalidControl)?.findIndex(
        (el) => el.tagName == 'INPUT' || el.tagName == 'MAT-SELECT'
      );
      if (inputIndex >= 0) {
        (invalidControl[inputIndex] as HTMLElement).focus();
      }

      //   let foundInvalidControl = false;
      //   for (const key of Object.keys(this.addressForm.controls)) {
      //     if (
      //       key != 'homeAddress' &&
      //       key != 'previousAddress' &&
      //       key != 'postalAddress'
      //     ) {
      //       if (this.addressForm.controls[key].invalid) {
      //         const invalidControl = this.el.nativeElement.querySelector(
      //           '[formcontrolname="' + key + '"]'
      //         );
      //         invalidControl.focus();
      //         foundInvalidControl = true;
      //         break;
      //       }
      //     }
      //   }
      //   if(!foundInvalidControl){
      //   for (const key of Object.keys(
      //     this.addressForm.controls.homeAddress.value)){
      //     if (this.addressForm.controls.homeAddress.get(key).invalid) {
      //       let flag = false;
      //       const invalidControl = this.el.nativeElement.querySelectorAll(
      //         '[formcontrolname="' + key + '"]'
      //       );
      //       invalidControl?.forEach((el) => {
      //         if (!flag) {
      //           const invalidInput = el.classList.value.includes('ng-invalid');
      //           if (invalidInput) {
      //             flag = true;
      //             el.focus();
      //             foundInvalidControl = true;
      //           }
      //         }
      //       });
      //       if (flag) {
      //         break;
      //       }
      //     }
      //   }
      // }
      //  if(!foundInvalidControl){
      //   for (const key of Object.keys(
      //     this.addressForm.controls.previousAddress.value)){
      //     if (this.addressForm.controls.previousAddress.get(key).invalid) {
      //       let flag = false;
      //       const invalidControl = this.el.nativeElement.querySelectorAll(
      //         '[formcontrolname="' + key + '"]'
      //       );
      //       invalidControl?.forEach((el) => {
      //         if (!flag) {
      //           const invalidInput = el.classList.value.includes('ng-invalid');
      //           if (invalidInput) {
      //             flag = true;
      //             el.focus();
      //             foundInvalidControl = true;
      //           }
      //         }
      //       });
      //       if (flag) {
      //         break;
      //       }
      //     }
      //   }
      // }
      //   if(!foundInvalidControl){
      //   for (const key of Object.keys(
      //     this.addressForm.controls.postalAddress.value)) {
      //     if (this.addressForm.controls.postalAddress.get(key).invalid) {
      //       let flag = false;
      //       const invalidControl = this.el.nativeElement.querySelectorAll(
      //         '[formcontrolname="' + key + '"]'
      //       );
      //       invalidControl?.forEach((el) => {
      //         if (!flag) {
      //           const invalidInput = el.classList.value.includes('ng-invalid');
      //           if (invalidInput) {
      //             flag = true;
      //             el.focus();
      //             foundInvalidControl = true;
      //           }
      //         }
      //       });
      //       if (flag) {
      //         break;
      //       }
      //     }
      //   }
      // }

      this.loadingService.stopLoading();
      return;
    }

    if (this.addressId) {
      if (this.currentApplication == 'superannuation') {
        const personalData = {
          contactId: this.contactId,
          leadFor: 1,
          firstname: this.applicationForm.get('firstname').value,
          lastname: this.applicationForm.get('lastname').value,
          birthdate: this.applicationForm.get('birthdate').value,
          gendercode: this.applicationForm.get('gendercode').value,
          pst_identityvoiresult: this.auth.getFieldDataFromToken(
            'pst_identityvoiresult'
          ),
          new_creditscorelatestreportdate: this.auth.getFieldDataFromToken(
            'new_creditscorelatestreportdate'
          ),
        };
        if (personalData.pst_identityvoiresult != true) {
          this.hitVOitrigger();
        }
        this.addressForm.patchValue(personalData);
      } else {
        if (!this.addressForm.dirty) {
          this.goNext();
          // this.loadingService.stopLoading();
          return;
        }
      }

      const formData = {
        ...this.addressForm.getRawValue(),
        needMailSystem: true,
      };
      const token = this.auth.getUserAccessToken();
      this.loading = true;
      this.userService
        .updateAddress(token, formData)
        .subscribe
        // (response) => {
        //   this.loading = false;
        //   this.goNext();
        //   // this.loadingService.stopLoading();
        // },
        // (err) => {
        //   this.loadingService.stopLoading();
        //   this.loading = false;
        //   console.log(err);
        // }
        ();
      this.loading = false;
      this.goNext();
    } else {
      if (this.currentApplication == 'superannuation') {
        const personalData = {
          contactId: this.contactId,
          leadFor: 1,
          firstname: this.applicationForm.get('firstname').value,
          lastname: this.applicationForm.get('lastname').value,
          birthdate: this.applicationForm.get('birthdate').value,
          gendercode: this.applicationForm.get('gendercode').value,
          pst_identityvoiresult: this.auth.getFieldDataFromToken(
            'pst_identityvoiresult'
          ),
          new_creditscorelatestreportdate: this.auth.getFieldDataFromToken(
            'new_creditscorelatestreportdate'
          ),
        };

        this.addressForm.patchValue(personalData);
        if (personalData.pst_identityvoiresult != true) {
          this.hitVOitrigger();
        }
      }
      this.loading = true;
      const formData = {
        ...this.addressForm.getRawValue(),
        needMailSystem: true,
      };
      const token = this.auth.getUserAccessToken();
      this.userService
        .saveAddress(token, formData)
        .subscribe
        // (response) => {
        //   this.loading = false;
        //   this.goNext();
        //   this.loadingService.stopLoading();
        // },
        // (err) => {
        //   this.loadingService.stopLoading();
        //   this.loading = false;
        //   console.log(err);
        // }
        ();
      this.loading = false;
      this.goNext();
    }
  }
  hitVOitrigger() {
    const token = this.auth.getUserAccessToken();
    const formdata = {
      contactId: this.auth.getLoginUserId(),
    };
    this.userService.rapidVOITrigger(token, formdata).subscribe(
      (data) => {},
      (error) => {
        // this.loadingService.stopLoading();
        console.log(error);
        this.auth.showSnackBarMsg('Something went wrong!');
      }
    );
  }

  goNext() {
    this.auth.gotoUrl(this.nextUrl);
  }
  // Dialog Box
  openDialog(headline: string) {
    const dialogRef = this.dialog.open(LoginComponent, {
      width: '500px',
      data: {
        headline,
        email: this.applicationForm.controls.emailaddress1.value,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result == 'loggedIn') {
        } else if (result == 'forgotPassword') {
          this.openForgotDialog();
        } else if (result == 'otpLogin') {
          this.loginOtp();
        } else if (result == 'onRegister') {
        }
      }
    });
  }
  loginOtp() {
    const dialogRef = this.dialog.open(LoginOtpComponent, {
      width: '500px',
      data: {},
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result == 'loggedIn') {
          const userData = this.auth.getDecodedUserAccessToken();
          if (userData) {
            this.setformdata(userData);
            // this.ngOnInit();
            window.scroll(0, 0);
          }
        } else if (result == 'backToLogin') {
          this.openDialog('LOGIN TO YOUR ACCOUNT');
        } else if (result == 'forgotPassword') {
          this.openForgotDialog();
        } else if (result == 'onRegister') {
        }
      }
    });
  }
  openForgotDialog() {
    const dialogRef = this.dialog.open(ForgotPasswordComponent, {
      width: '500px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result == 'backToLogin') {
          this.openDialog('LOGIN TO YOUR ACCOUNT');
        }
      }
    });
  }
  checkCurrentUrl() {
    // const currentUrl = this.router.url.split('?')[0];
    const currentUrl = this.auth.getCurrentUrl();
    this.currenUrl = currentUrl;
    switch (currentUrl) {
      case '/debtapp': {
        this.header = 'Finance Application';
        this.totalStage = 10;
        this.currentApplication = 'debtapp';
        this.nextUrl = '/financial-goal';
        break;
      }
      case '/superannuation': {
        this.header = 'Join Cashel Super and Pension';
        this.totalStage = 9;
        this.currentApplication = 'superannuation'; //
        this.nextUrl = '/superannuation/confirm-identity-and-income';

        break;
      }
      case '/managed-account': {
        this.header = 'Apply for Cashel Managed Account';
        this.totalStage = 6;
        this.currentApplication = 'managedAccount'; //
        this.nextUrl = '/managed-account/investment-risk-profile';
        break;
      }
      case '/general-insurance': {
        this.header = 'Apply for General Insurance';
        this.totalStage = 4;
        this.currentApplication = 'generalInsurance'; //
        this.nextUrl = '/general-insurance/insurance-advice';
        break;
      }
      case '/health-insurance': {
        this.header = 'Apply for Health Insurance Review';
        this.totalStage = 4;
        this.currentApplication = 'healthInsurance'; //
        this.nextUrl = '/health-insurance/insurance';
        break;
      }
      case '/estate-planning': {
        this.header = 'Obtain Estate Planning Assistance';
        this.totalStage = 10;
        this.currentApplication = 'estatePlanning'; //
        this.nextUrl = 'estate-planning/tell-us-about-your-family';
        break;
      }
      case '/life-insurance': {
        this.header = 'Apply for Life and Personal Insurance.';
        this.totalStage = 12;
        this.currentApplication = 'lifeInsurance';
        this.nextUrl = 'life-insurance/confirm-identity-and-income';
        break;
      }
      case '/financial-planning': {
        this.header = 'Obtain Financial Planning Advice.';
        this.totalStage = 12;
        this.currentApplication = 'financialPlanning';
        this.nextUrl = 'financial-planning/financial-goal';
        break;
      }
      default: {
        // statements;
        break;
      }
    }
  }
  validateOpportunity() {
    const contactId = this.auth.getPrimaryUserId();
    const accountId = this.auth.getUserAccountId();
    const userData = this.auth.getDecodedUserAccessToken();
    const userFullName = userData.contactDetails[0].fullname;
    if (this.currentApplication == 'superannuation') {
      const currentSuperOppId = this.auth.getCurrentSuperOpportunityId();
      if (!currentSuperOppId) {
        this.addSuperOpportunity(contactId, accountId, userFullName);
      }
    } else if (this.currentApplication == 'managedAccount') {
      const currentInvestmentOppId =
        this.auth.getCurrentInvestmentOpportunityId();
      if (!currentInvestmentOppId) {
        this.addinvestmentOpportunity(contactId, accountId, userFullName);
      }
    } else if (this.currentApplication == 'estatePlanning') {
      const currentOpp = this.auth.getCurrentEstatePlanningOpportunityId();
      if (!currentOpp) {
        this.addEstatePlanningOpportunity(contactId, accountId, userFullName);
      }
    } else if (this.currentApplication == 'healthInsurance') {
      const currentOpp = this.auth.getCurrentHealthInsuranceOpportunityId();
      if (!currentOpp) {
        this.addHealthOpportunity(contactId, accountId, userFullName);
      }
    } else if (this.currentApplication == 'generalInsurance') {
      const currentgeneralInsuranceOppId =
        this.auth.getCurrentGeneralInsuranceOpportunityId();
      if (!currentgeneralInsuranceOppId) {
        this.addGenralOpportunity(contactId, accountId, userFullName);
      }
    } else if (this.currentApplication == 'lifeInsurance') {
      const currentOppId = this.auth.getCurrentLifeInsuranceOpportunityId();
      if (!currentOppId) {
        this.addlifeOpportunity(contactId, accountId, userFullName);
      }
    } else if (this.currentApplication == 'financialPlanning') {
      const currentOppId = this.auth.getCurrentFinancialPlanningOpportunityId();
      if (!currentOppId) {
        this.addfinanceOpportunity(contactId, accountId, userFullName);
      }
    }
  }

  addSuperOpportunity(
    contactId: string,
    accountId: string,
    userFullName: string
  ) {
    const formData = {
      userFullName,
      contactId,
      accountID: accountId,
      leadFor: 1,
    };
    this.loadingService.startLoading();
    this.userService.saveFinancial(formData).subscribe(
      (response) => {
        this.loadingService.stopLoading();
        if (response) {
          this.auth.setCurrentSuperOpportunityId(response.data.opportunityid);
          const newopp = {
            name: `${formData.userFullName} - Superannuation Application`,
            opportunityid: response.data.opportunityid,
            _bpf_opportunityid_value: response.data.opportunityid,
            // _new_investmentaccount_value: response.data.investmentid,
            tlx_leadfor: 1,
            businessprocessflowinstanceid:
              response.data.businessprocessflowinstanceid,
            _activestageid_value: '2ee1ba75-0b75-40c9-9a75-9106f4182f16',
            _activestageid_value_Formatted: 'Complete Fact Find',
          };
          const allOpportunity = this.auth.getAllOpportunity();
          const newData = [...allOpportunity, newopp];
          this.auth.setOpportunityinSession(newData);
          this.auth.updateSideBar();
          window.scroll(0, 0);
        }
      },
      (error) => {
        console.log(error);
        this.loadingService.stopLoading();
        this.auth.showSnackBarMsg(error.error.message);
      }
    );
    // }
  }
  addinvestmentOpportunity(
    contactId: string,
    accountId: string,
    userFullName: string
  ) {
    const formData = {
      userFullName,
      contactId,
      accountID: accountId,
      leadFor: 9,
    };
    this.loadingService.startLoading();
    this.userService.saveFinancial(formData).subscribe(
      (response) => {
        this.loadingService.stopLoading();
        if (response) {
          this.auth.setCurrentInvestmentOpportunityId(
            response.data.opportunityid
          );
          const newopp = {
            name: `${formData.userFullName} - Managed Investment Application`,
            opportunityid: response.data.opportunityid,
            _bpf_opportunityid_value: response.data.opportunityid,
            tlx_leadfor: 9,
            businessprocessflowinstanceid:
              response.data.businessprocessflowinstanceid,
            _activestageid_value: '56b2b8c3-810b-4538-b3da-dcabd8b82a27',
            _activestageid_value_Formatted: 'Complete Fact Find',
          };
          const allOpportunity = this.auth.getAllOpportunity();
          const newData = [...allOpportunity, newopp];
          this.auth.setOpportunityinSession(newData);
          this.auth.updateSideBar();
          window.scroll(0, 0);
        }
      },
      (error) => {
        console.log(error);
        this.loadingService.stopLoading();
        this.auth.showSnackBarMsg(error.error.message);
      }
    );
    // }
  }
  addEstatePlanningOpportunity(
    contactId: string,
    accountId: string,
    userFullName: string
  ) {
    const formData = {
      userFullName,
      contactId,
      accountID: accountId,
      leadFor: 6,
    };
    this.loadingService.startLoading();
    this.userService.saveFinancial(formData).subscribe(
      (response) => {
        this.loadingService.stopLoading();
        if (response) {
          this.auth.setCurrentHealthInsuranceOpportunityId(
            response.data.opportunityid
          );
          const newopp = {
            name: `${formData.userFullName} - Estate Planning Application`,
            opportunityid: response.data.opportunityid,
            _bpf_opportunityid_value: response.data.opportunityid,
            // _new_investmentaccount_value: response.data.investmentid,
            tlx_leadfor: 6,
            businessprocessflowinstanceid:
              response.data.businessprocessflowinstanceid,
            _activestageid_value: 'd408967b-797a-48f2-9200-4233ff61d00d',
            _activestageid_value_Formatted: 'Complete Fact Find',
          };
          const allOpportunity = this.auth.getAllOpportunity();
          const newData = [...allOpportunity, newopp];
          this.auth.setOpportunityinSession(newData);
          this.auth.updateSideBar();
          window.scroll(0, 0);
        }
      },
      (error) => {
        console.log(error);
        this.loadingService.stopLoading();
        this.auth.showSnackBarMsg(error.error.message);
      }
    );
    // }
  }
  addHealthOpportunity(
    contactId: string,
    accountId: string,
    userFullName: string
  ) {
    const formData = {
      userFullName,
      contactId,
      accountID: accountId,
      leadFor: 5,
    };
    this.loadingService.startLoading();
    this.userService.saveFinancial(formData).subscribe(
      (response) => {
        this.loadingService.stopLoading();
        if (response) {
          this.auth.setCurrentHealthInsuranceOpportunityId(
            response.data.opportunityid
          );

          const newopp = {
            name: `${formData.userFullName} - Health Insurance Application`,
            opportunityid: response.data.opportunityid,
            _bpf_opportunityid_value: response.data.opportunityid,
            // _new_investmentaccount_value: response.data.investmentid,
            tlx_leadfor: 5,
            businessprocessflowinstanceid:
              response.data.businessprocessflowinstanceid,
            _activestageid_value: 'a7e8150f-e667-4e32-a250-9f0e2aa4f1e9',
            _activestageid_value_Formatted: 'Complete Fact Find',
          };
          const allOpportunity = this.auth.getAllOpportunity();
          const newData = [...allOpportunity, newopp];
          this.auth.setOpportunityinSession(newData);
          this.auth.updateSideBar();
          window.scroll(0, 0);
        }
      },
      (error) => {
        console.log(error);
        this.loadingService.stopLoading();
        this.auth.showSnackBarMsg(error.error.message);
      }
    );
    // }
  }
  addGenralOpportunity(
    contactId: string,
    accountId: string,
    userFullName: string
  ) {
    const formData = {
      userFullName,
      contactId,
      accountID: accountId,
      leadFor: 4,
    };
    this.loadingService.startLoading();
    this.userService.saveFinancial(formData).subscribe(
      (response) => {
        this.loadingService.stopLoading();
        if (response) {
          this.auth.setCurrentGeneralInsuranceOpportunityId(
            response.data.opportunityid
          );
          const newopp = {
            name: `${formData.userFullName} - General Insurance Application`,
            opportunityid: response.data.opportunityid,
            _bpf_opportunityid_value: response.data.opportunityid,
            // _new_investmentaccount_value: response.data.investmentid,
            tlx_leadfor: 4,
            businessprocessflowinstanceid:
              response.data.businessprocessflowinstanceid,
            _activestageid_value: '1e95aa1f-ce10-4a49-869f-73a17d4291cd',
            _activestageid_value_Formatted: 'Complete Fact Find',
          };
          const allOpportunity = this.auth.getAllOpportunity();
          const newData = [...allOpportunity, newopp];
          this.auth.setOpportunityinSession(newData);
          this.auth.updateSideBar();

          this.loadingService.stopLoading();
          window.scroll(0, 0);
        }
      },
      (error) => {
        console.log(error);
        this.loadingService.stopLoading();
        this.auth.showSnackBarMsg(error.error.message);
      }
    );
    // }
  }
  addlifeOpportunity(
    contactId: string,
    accountId: string,
    userFullName: string
  ) {
    const formData = {
      userFullName,
      contactId,
      accountID: accountId,
      leadFor: 3,
    };
    this.loadingService.startLoading();
    this.userService.saveFinancial(formData).subscribe(
      (response) => {
        this.loadingService.stopLoading();
        if (response) {
          this.auth.setCurrentLifeInsuranceOpportunityId(
            response.data.opportunityid
          );
          const newopp = {
            name: `${formData.userFullName} - Life and Personal Insurance Application`,
            opportunityid: response.data.opportunityid,
            _bpf_opportunityid_value: response.data.opportunityid,
            // _new_investmentaccount_value: response.data.investmentid,
            tlx_leadfor: 3,
            // businessprocessflowinstanceid:
            //   response.data.businessprocessflowinstanceid,
            // _activestageid_value: '1e95aa1f-ce10-4a49-869f-73a17d4291cd',
            // _activestageid_value_Formatted: 'Complete Fact Find',
          };
          const allOpportunity = this.auth.getAllOpportunity();
          const newData = [...allOpportunity, newopp];
          this.auth.setOpportunityinSession(newData);
          this.auth.updateSideBar();
          this.loadingService.stopLoading();
          window.scroll(0, 0);
        }
      },
      (error) => {
        console.log(error);
        this.loadingService.stopLoading();
        this.auth.showSnackBarMsg(error.error.message);
      }
    );
    // }
  }
  addfinanceOpportunity(
    contactId: string,
    accountId: string,
    userFullName: string
  ) {
    const formData = {
      userFullName,
      contactId,
      accountID: accountId,
      leadFor: 7,
    };
    this.loadingService.startLoading();
    this.userService.saveFinancial(formData).subscribe(
      (response) => {
        this.loadingService.stopLoading();
        if (response) {
          this.auth.setCurrentFinancialPlanningOpportunityId(
            response.data.opportunityid
          );
          const newopp = {
            name: `${formData.userFullName} - Financial Planning Application`,
            opportunityid: response.data.opportunityid,
            _bpf_opportunityid_value: response.data.opportunityid,
            // _new_investmentaccount_value: response.data.investmentid,
            tlx_leadfor: 7,
            businessprocessflowinstanceid:
              response.data.businessprocessflowinstanceid,
            _activestageid_value: '97f16148-4f74-4ead-887d-c3546a6e8cf9',
            _activestageid_value_Formatted: 'Confirm Financial Planning Needs',
          };
          const allOpportunity = this.auth.getAllOpportunity();
          const newData = [...allOpportunity, newopp];
          this.auth.setOpportunityinSession(newData);
          this.auth.updateSideBar();

          this.loadingService.stopLoading();
          window.scroll(0, 0);
        }
      },
      (error) => {
        console.log(error);
        this.loadingService.stopLoading();
        this.auth.showSnackBarMsg(error.error.message);
      }
    );
    // }
  }
}
